/** Situações dos tipos de itens */
export interface ItemTipoSituacao {
    id: number,
    nome: string;
}

export const itemTipoAtivo: ItemTipoSituacao = {id: 1, nome: 'Ativo'};
export const itemTipoInativo: ItemTipoSituacao = {id: 2, nome: 'Inativo'};

export const itemTipoSituacoes: ItemTipoSituacao[] = [
    itemTipoAtivo,
    itemTipoInativo
];

/** Verifica se a situação do tipo de item é Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === itemTipoAtivo.id;
}

/** Verifica se a situação do tipo de item é Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === itemTipoInativo.id;
}
